import { PayrollVoucherStatusEnum } from "@/enum/payroll-voucher-status";
import { useGetPayrollVoucherStatusCountsQuery } from "@/services/payroll-voucher";

import { ALL_STATUS_FILTER } from "../constants";
import { DateRange, StatusFilterKey } from "../types";

export const useVoucherStatusCounts = (
  range: DateRange,
): Record<StatusFilterKey, number> => {
  const { data } = useGetPayrollVoucherStatusCountsQuery({
    start: range.start,
    end: range.end,
  });

  return {
    [ALL_STATUS_FILTER]: data?.all ?? 0,
    // O RH nunca recebe vale aguardando fechamento (ADR-PAY-005): a chave existe
    // só para o Record cobrir o enum, e o contador é sempre zero.
    [PayrollVoucherStatusEnum.AWAITING_CLOSING]: 0,
    [PayrollVoucherStatusEnum.PENDING]: data?.pending ?? 0,
    [PayrollVoucherStatusEnum.APPROVED]: data?.approved ?? 0,
    [PayrollVoucherStatusEnum.REJECTED]: data?.rejected ?? 0,
  };
};
